/**
 * Where every "Book a Demo" button on the marketing site points.
 *
 * Kept apart from `constants/demo.ts` so a template that only needs the link
 * does not pull the /demo page's copy into its bundle.
 *
 * The `source` query parameter records which CTA was clicked; the /demo page
 * passes it to `/api/contact` and to GA4 as `form_source`. It never creates a
 * second indexable URL: /demo's canonical is the bare path, whatever query it
 * was reached with, and UTM or click-ID parameters added by a campaign ride
 * alongside it untouched (see `utils/campaignAttribution.ts`).
 */
export const DEMO_PATH = '/demo';

/** `/demo?source=<source>` — the link a CTA uses to say where the visitor came from. */
export const demoHref = (source: string) => `${DEMO_PATH}?source=${encodeURIComponent(source)}`;
